// src/theme/theme.js
import { createTheme } from "@mui/material/styles";
import colors from "./colors";

// 1. الاستدعاء بالأسماء الجديدة المحدثة
const { primary, secondary, grey, error, common } = colors;

export const getAppTheme = (mode = "light") => {
  return createTheme({
    direction: "rtl",
    shape: { borderRadius: "10px",padding:'10px'},
    spacing: 10, 

    // 2. تحديث الـ Palette بالأسماء الجديدة
    palette: {
      mode,
      primary: { ...primary, main: primary[500], contrastText: common.white },
      secondary: { ...secondary, main: secondary[500], contrastText: common.white },
      error: { ...error, main: error[500] },
      warning: { main: common.orange },

      background: {
        default: mode === "dark" ? grey[900] : grey[50],
        paper: mode === "dark" ? grey[800] : common.white,
      },
      text: {
        primary: mode === "dark" ? grey[50] : grey[900],
        secondary: mode === "dark" ? secondary[200] : secondary[500],
        light:mode === "dark" ? grey[900] : grey[50],
        hint: mode === "dark" ? grey[300] : grey[400],
        errorHint: mode === "dark" ? error[800] : error[300],
      },

      // 3. تحديث الألوان المخصصة (Semantic Custom Colors)
      custom: {
        glassBg: mode === "dark" ? `${grey[800]}88` : `${primary[100]}88`,
        glassBorder: mode === "dark" ? grey[900] : primary[200],
        pageTitle: mode === "dark" ? primary[200] : primary[800],
        badgeBg: mode === "dark" ? primary[900] : primary[50],
        badgeText: mode === "dark" ? primary[100] : grey[500],
        hintBorder: mode === "dark" ? grey[700] : grey[100],
        errorHintBorder: mode === "dark" ? error[800] : error[100],
        sectionBorder: mode === "dark" ? primary[900] : primary[100],
        
      },

    
    },

    typography: {
      fontFamily: '"Tajawal"',
    },

    components: {
      // --- النصوص ---
      MuiTypography: {
        variants: [
          {
            props: { variant: "pageTitle" },
            style: ({ theme }) => ({
              fontSize: "1.6rem",
              fontWeight: 700,
              color: theme.palette.custom.pageTitle, 
            }),
          },
          {
            props: { variant: "sectionTitle" },
            style: ({ theme }) => ({
              fontSize: "1.2rem",
              padding: theme.spacing(1),
              fontWeight: 600,
              color: theme.palette.text.secondary,
            }),
          },
          {
            props: { variant: "minBadge" },
            style: ({ theme }) => ({
              backgroundColor: theme.palette.custom.badgeBg,
              color: theme.palette.custom.badgeText,
              fontSize: "1rem",
              padding: theme.spacing(1),
              borderRadius: theme.shape.borderRadius,
              fontWeight: 600,
            }),
          },
          {
            props: { variant: "hint-card" },
            style: ({ theme }) => ({
              width: "100%",
              textAlign: "center",
              fontSize: "1.1rem",
              fontWeight: 600,
              color: theme.palette.text.secondary,
              border: `2px solid ${theme.palette.custom.hintBorder}`,
              padding: theme.spacing(1),
              borderRadius: theme.shape.borderRadius,
              cursor: "pointer",
            }),
          },

          {
            props: { variant: "error-hint-card" },
            style: ({ theme }) => ({
              textAlign: "center",
              fontSize: "1.1rem",
              fontWeight: 600,
              color: theme.palette.text.errorHint,
              border: `2px solid ${theme.palette.custom.errorHintBorder}`,
              padding: theme.spacing(1),
              borderRadius: theme.shape.borderRadius,
              cursor: "pointer",
            }),
          },

          {
            props: { variant: "hint" },
            style: ({ theme }) => ({
              textAlign: "center",
              fontSize: "0.8rem",
              fontWeight: 600,
              color: theme.palette.text.hint,
              padding: theme.shape.padding,
            }),
          },
          {
            props: { variant: "text" },
            style: ({ theme }) => ({
              // textAlign: "center",
              fontSize: "0.8rem",
              fontWeight: 600,
              color: theme.palette.text.primary,
              padding: theme.shape.padding,
            }),
          },
        ],
      },

      // --- الأزرار ---
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: 10,
            textTransform: "none",
            fontWeight: 600,
          }),
        },
        variants: [
          {
            props: { variant: "ghost" },
            style: ({ theme }) => ({
              backgroundColor: "transparent",
              color: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.custom.badgeBg,
              },

              
            }),
          },
          {
            props: { variant: "contained" },
            style: ({ theme }) => ({
              width: 'fit-content', // تم تصحيح الكلمة
              borderRadius: theme.shape.borderRadius, // هذا السطر صحيح وممتاز
              
              // استخدام theme.spacing يعتمد على الرقم الذي وضعته في إعدادات الثيم
              // مثلاً: (1, 3) تعني 1 من أعلى وأسفل، و 3 من اليمين واليسار (لجعل الزر أعرض قليلاً)
              padding: theme.spacing(1, 3), 
              
              // مسافة خارجية بسيطة
              margin: theme.spacing(1), 
              
              // إضافة لمسة جمالية: خط أعرض قليلاً
              fontWeight: 600, 
              color:theme.palette.text.light
            }),
          },
        ],
      },

      // --- حقول الإدخال ---
      MuiInputBase: {
        defaultProps: { inputProps: { dir: "auto" } },
        styleOverrides: {
          input: { unicodeBidi: "plaintext" },
          inputMultiline: { unicodeBidi: "plaintext" },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: 10,
            backgroundColor: theme.palette.background.default,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.custom.border,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.primary.light,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.primary.main,
              borderWidth: 1,
            },
          }),
        },
      },

      // --- الحاويات والأسطح ---
      MuiPaper: {
        variants: [
          {
            props: { variant: "section" },
            style: ({ theme }) => ({
              borderRadius:theme.shape.borderRadius,
              padding: theme.shape.padding,
              backgroundColor: theme.palette.background.paper,
              border: `2px solid ${theme.palette.custom.sectionBorder}`,
              // boxShadow: mode === "dark" ? "none" : `0px 1px 2px ${theme.palette.primary[100]}`,
            }),
          },
          {
            props: { variant: "glass" },
            style: ({ theme }) => ({
              borderRadius: theme.shape.borderRadius,
              padding: theme.shape.padding,
              backgroundColor: theme.palette.custom.glassBg,
              backdropFilter: "saturate(100%) blur(3px)",
              boxShadow: mode === "dark" ? "none" : `0px 2px 4px ${theme.palette.primary[100]}`,
            }),
          },
        ],
      },
    },
  });
};

export default getAppTheme;